import React, { Component } from "react";
// import logo from "./logo.svg";
import "./App.css";
// import { address } from "ip";
import services from "./services.json";
import _ from "lodash";

// declare var netlifyIdentity;
const netlifyIdentity = window.netlifyIdentity;

class App extends Component {
  state = {
    name: "",
    telephone: "",
    area: "",
    address: "",
    price: 0,
    finalPrice: 130,
    paymentDone: "no",
    services: [],
    selectedItems: [],
    hanimexUser: netlifyIdentity.currentUser()
  };

  buildOptions() {
    var arr = [];

    for (let i = 0; i < services.length; i++) {
      arr.push(
        <option key={i} value={i}>
          {services[i].name}
        </option>
      );
    }

    return arr;
  }

  handlePaymentDoneChange = changeEvent => {
    this.setState({
      paymentDone: changeEvent.target.value
    });
  };

  handleServiceChange = event => {
    const selectedServices = _.map(
      event.target.selectedOptions,
      item => services[item.value]
    );
    this.setState({
      selectedItems: _.map(event.target.selectedOptions, item => item.value),
      services: selectedServices
    });
    // console.log(selectedServices);
    const price = _.reduce(
      selectedServices,
      (sum, service) => {
        return sum + service.price;
      },
      0
    );

    let finalPrice = 130;

    if (price <= 130) {
      finalPrice = 130;
      document.getElementById("finalPriceNote").hidden = false;
      document.getElementById("priceDiv").hidden = false;
    } else {
      finalPrice = price;
      document.getElementById("finalPriceNote").hidden = true;
      document.getElementById("priceDiv").hidden = true;
    }
    this.setState({
      price: price,
      finalPrice: finalPrice
    });
    // console.log(price);
    this.handleChange(event);
  };

  handleChange(e) {
    e.target.classList.add("active");

    this.setState({
      [e.target.name]: e.target.value
    });

    this.showInputError(e.target.name);
  }

  handleSubmit = e => {
    console.log("component state", this.state);

    if (!this.showFormErrors()) {
      // console.log("form is invalid: do not submit");
      e.preventDefault();
    } else {
      // console.log("form is valid: submit");
      let counter = 0;
      const servicesElement = document.getElementById("services");
      const servicesText = _.reduce(
        this.state.services,
        (sum, service) => {
          counter++;
          return sum + counter + "- " + service.name + "\n";
        },
        ""
      );
      servicesElement.value = servicesText;

      const telephone = document.getElementById("telephone");
      telephone.value = "2" + telephone.value;

      // e.preventDefault();
      // const form = document.getElementById("orderForm");
      // for (var i = 0; i < form.length; i++) {
      //   console.log(form[i].name + ": " + form[i].value);
      // }
    }
  };

  showFormErrors() {
    const inputs = document.querySelectorAll("input, textarea, select");
    let isFormValid = true;

    inputs.forEach(input => {
      input.classList.add("active");

      const isInputValid = this.showInputError(input.name);

      if (!isInputValid) {
        isFormValid = false;
      }
    });

    return isFormValid;
  }

  showInputError(refName) {
    if (this.refs[refName]) {
      const validity = this.refs[refName].validity;
      const label = document.getElementById(`${refName}Label`).textContent;
      const error = document.getElementById(`${refName}Error`);

      if (refName === "telephone") {
        const telephone = this.refs[refName].value;
        var reg = /^\d+$/;
        var regHome = /^02/;
        var regMobile = /^01/;
        const invalid = document.getElementById("telephoneInvalid");
        if (
          reg.test(telephone) &&
          ((regMobile.test(telephone) && telephone.length === 11) || (regHome.test(telephone) && telephone.length === 10))
        ) {
          invalid.hidden = true;
          this.refs[refName].setCustomValidity("");
        } else {
          invalid.hidden = false;
          this.refs[refName].setCustomValidity("Invalid Telephone");
          return false;
        }
      }

      if (!validity.valid) {
        if (validity.valueMissing) {
          error.textContent = `يجب إدخال ${label}`;
        } else if (validity.typeMismatch) {
          error.textContent = `${label} غير صحيح`;
        }
        return false;
      }

      if (error) {
        error.textContent = "";
      }
    }
    return true;
  }

  netlifyLogout() {
    netlifyIdentity.logout();
  }

  netlifyLogin(user) {
    netlifyIdentity.open();
  }

  constructor(props) {
    super(props);
    netlifyIdentity.on("init", user => {
      this.setState({ hanimexUser: user });
    });
    netlifyIdentity.on("login", user => {
      this.setState({ hanimexUser: user });
    });
    netlifyIdentity.on("logout", () => {
      this.setState({ hanimexUser: null });
    });
    netlifyIdentity.on("error", err => {
      this.setState({ hanimexUser: null });
    });
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    return (
      <div className="App">
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p> */}
        <br />
        <div className="container">
          {!this.state.hanimexUser ? (
            <div
              className="btn btn-clear centered btn-lg btn-block"
              id="buttonLogin"
              onClick={this.netlifyLogin}
            >
              Login
            </div>
          ) : (
            <div>
              <div
                className="btn btn-clear centered btn-lg btn-block"
                id="buttonLogout"
                onClick={this.netlifyLogout}
              >
                {this.state.hanimexUser.email} - خروج؟
              </div>
              <form id="orderForm" method="post">
                <input type="hidden" name="form-name" value="orderForm" />
                <div className="form-group row">
                  <label
                    htmlFor="name"
                    className="col-sm-2 col-form-label"
                    id="nameLabel"
                  >
                    الأسم
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      ref="name"
                      placeholder="الأسم"
                      required
                      value={this.state.name}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="nameError" />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="telephone"
                    className="col-sm-2 col-form-label"
                    id="telephoneLabel"
                  >
                    التليفون المحمول
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="telephone"
                      name="telephone"
                      ref="telephone"
                      placeholder="التليفون المحمول"
                      required
                      value={this.state.telephone}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="telephoneError" />
                    <div className="error" id="telephoneInvalid" hidden>
                      رقم التليفون غير صحيح
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="area"
                    className="col-sm-2 col-form-label"
                    id="areaLabel"
                  >
                    المنطقة
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="area"
                      name="area"
                      ref="area"
                      placeholder="المنطقة"
                      required
                      value={this.state.area}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="areaError" />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="address"
                    className="col-sm-2 col-form-label"
                    id="addressLabel"
                  >
                    العنوان
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      ref="address"
                      placeholder="العنوان"
                      required
                      value={this.state.address}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="addressError" />
                  </div>
                </div>

                <div className="form-group row">
                  <label
                    className="col-sm-2 col-form-label"
                    htmlFor="selectServices"
                    id="selectServicesLabel"
                  >
                    الخدمات
                  </label>
                  <div className="col-sm-10">
                    {/* <select multiple className="form-control" id="selectServices">
        </select> */}

                    <select
                      multiple
                      value={this.state.selectedItems}
                      onChange={this.handleServiceChange}
                      className="form-control"
                      id="selectServices"
                      name="selectServices"
                      ref="selectServices"
                      required
                    >
                      {this.buildOptions()}
                    </select>

                    {/* <Selector
                      value={this.state.services}
                      handleChange={this.handleServiceChange}
                      id="selectServices"
                      ref="selectServices"
                    /> */}
                    <div className="error" id="selectServicesError" />
                  </div>
                </div>
                <div className="form-group row" id="priceDiv">
                  <label
                    htmlFor="price"
                    className="col-sm-2 col-form-label"
                    id="priceLabel"
                  >
                    السعر
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="price"
                      name="price"
                      ref="price"
                      placeholder="السعر"
                      readOnly
                      value={this.state.price}
                      onChange={this.handleChange}
                    />
                    <div className="error" id="priceError" />
                  </div>
                </div>
                <div className="form-group row" id="finalPriceDiv">
                  <label
                    htmlFor="finalPrice"
                    className="col-sm-2 col-form-label"
                    id="finalPriceLabel"
                  >
                    السعر النهائي
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      id="finalPrice"
                      name="finalPrice"
                      ref="finalPrice"
                      placeholder="السعر النهائيس"
                      readOnly
                      value={this.state.finalPrice}
                    />
                    <div id="finalPriceNote">الحد الأدنى للسعر هو 130 جنيه</div>
                  </div>
                </div>
                <fieldset className="form-group">
                  <div className="row">
                    <label
                      className="col-form-label col-sm-2 pt-0"
                      id="paymentDoneLabel"
                    >
                      تم الدفع؟
                    </label>
                    <div className="col-sm-10">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentDone"
                          id="paymentDone1"
                          ref="paymentDone1"
                          value="yes"
                          checked={this.state.paymentDone === "yes"}
                          onChange={this.handlePaymentDoneChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="paymentDone1"
                        >
                          &nbsp;نعم
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentDone"
                          id="paymentDone2"
                          ref="paymentDone2"
                          value="no"
                          checked={this.state.paymentDone === "no"}
                          onChange={this.handlePaymentDoneChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="paymentDone2"
                        >
                          &nbsp;لا
                        </label>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <input type="hidden" name="services" id="services" />
                <input
                  type="hidden"
                  name="hanimexUser"
                  id="hanimexUser"
                  value={this.state.hanimexUser.email}
                />
                <div className="form-group row">
                  <div className="col-sm-10">
                    <button
                      id="sub"
                      type="submit"
                      className="btn btn-primary"
                      onClick={this.handleSubmit}
                    >
                      التأكيد
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js